import { render, staticRenderFns } from "./BaseDialogContainer.vue?vue&type=template&id=4f6daab5&scoped=true&"
import script from "./BaseDialogContainer.vue?vue&type=script&lang=js&"
export * from "./BaseDialogContainer.vue?vue&type=script&lang=js&"
import style0 from "./BaseDialogContainer.vue?vue&type=style&index=0&id=4f6daab5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6daab5",
  null
  
)

export default component.exports